import { AppContext } from 'contexts';

function App(): JSX.Element {
  return <AppContext />;
}

export default App;
